export const FooterStyle = {

    footer: {
        width: "100%",
        display: 'flex',
        alignItems:'center',
        flexDirection: 'row',
        justifyContent: 'center',
    },

    footerImage: {
        width: "100%",
        maxWidth: "37.5rem",
    },
}